import React from 'react'; // eslint-disable-line
import styled from 'styled-components';
import media from 'components/Media';

const ProductTitle = styled.div.attrs({ className: 'h1' })`
  ${media.down.phone`
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.6;
  `};
`;

export default ProductTitle;
